import { callApi } from "./api";

export const fetchPricebreaks = (designId, overrides) => {
  const data = new FormData();
  overrides.colors.forEach((color, index) => {
    Object.keys(color).forEach((key) => {
      data.append("colors[" + index + "][" + key + "]", color[key]);
    });
  });
  const params = {
    headers: {
      "Content-Type": null
    },
    method: "POST",
    credentials: "include",
    body: data
  };
  let url = `design/price_breaks/${designId}`;
  return callApi(url, params).then((response) => {
    if (response.response) {
      return { response: response.response };
    } else {
      return { error: response.error };
    }
  });
};
